/* eslint-disable @typescript-eslint/no-useless-constructor */
/* eslint-disable import/no-extraneous-dependencies */
import {
  transReportsCenterServiceHttpBindingInterceptor,
  TransReportsCenterService,
} from '@amzn/coral_com-amazon-transreportscenterservice';
import {
  CoralClientFactory,
  CoralFetchHandler,
  CoralHandler,
  CoralHttpConfig,
  InterceptingHandler,
} from '@amzn/ihm-js-coral-client';
import { TransReportsCenterServiceClientConfigFactory } from '@amzn/coral-config_trans-reports-center-service';
import RequestOptionsInterceptor from './PassportRequestOptionsInterceptor';
import CarrierLogisticsRequestOptionsInterceptor from './CarrierLogisticsRequestOptionsInterceptor';
import envHelper from '../config/env';
import externalModulePicker from '../utils/externalModulePicker';

const ResolvedRequestOptionsInterceptor = externalModulePicker(
  CarrierLogisticsRequestOptionsInterceptor,
  RequestOptionsInterceptor
);

const clientFactory = new CoralClientFactory(
  [TransReportsCenterServiceClientConfigFactory],
  envHelper.getEnv(),
  new InterceptingHandler(new CoralFetchHandler(), [
    transReportsCenterServiceHttpBindingInterceptor,
    new ResolvedRequestOptionsInterceptor(),
  ])
);

/**
 * Custom web server to override serialization/deserialization
 */
class CustomWebServer extends TransReportsCenterService {
  constructor(config: CoralHttpConfig, handler: CoralHandler) {
    super(config, handler);
  }
}

const TransReportsCenterServiceClient = clientFactory.get(CustomWebServer);

export default TransReportsCenterServiceClient;
